export function getScreenWidth() {
  return window.innerWidth;
}
